import type {
  ImportableErpPartDetailsQueryKey,
  UseImportableErpPartDetailsParams,
} from './types';

export const getImportableErpPartDetailsQueryKey = (
  params: UseImportableErpPartDetailsParams,
): ImportableErpPartDetailsQueryKey => [
  'quotes',
  'importHistoricalWork',
  'importableErpPartDetails',
  params,
];
